import { titleCase } from './SqliteHelp.js'
export function makeViewsCode(dbName, tableName, tableNames, tableDatas) {
    tableNames = JSON.parse(JSON.stringify(tableNames));
    tableDatas = JSON.parse(JSON.stringify(tableDatas));
    return `/// Author: Samle\n/// get create page:${tableName}
import 'dart:convert';
import 'package:flutter/cupertino.dart';
import 'package:flutter/material.dart';
import 'package:get/get.dart';

import '../controllers/${tableName}_controller.dart';

/// 特殊自定义组件
import '../../../../util/SearchFence.dart';
import '../../../../util/${tableName}_list_view.dart';
    
class ${titleCase(tableName)}View extends GetView<${titleCase(tableName)}Controller> {

  void checkDel(context,value) async {
    Get.defaultDialog(
      title: '确认删除？',
      radius: 10.0,
      barrierDismissible: false,
      content: const Text("请确认是否删除该条数据！"),
      confirm: MaterialButton(
        color: const Color.fromARGB(253, 2, 171, 153),
        textColor: Colors.white,
        child: const Text('确认', style: TextStyle(fontSize: 18.0,fontWeight: FontWeight.w600)),
        onPressed: () async {
          await controller.del${titleCase(tableName)}(value);
          Get.back();
          controller.onInit();
        },
      ),
      cancel: MaterialButton(
        color: Colors.white,
        textColor: Colors.black87,
        child: const Text('取消', style: TextStyle(fontSize: 18.0,fontWeight: FontWeight.w600)),
        onPressed: () {
          Get.back();
        },
      ),
    );
  }

  @override
  Widget build(BuildContext context) {
    return Scaffold(
      appBar: AppBar(
        ///leading: IconButton(
        ///  icon: const Icon(Icons.density_medium_sharp),
        ///  onPressed: (){},
        ///),
        elevation: 0,
        backgroundColor: Colors.black87,
        title: const Text('${titleCase(tableName)}'),
        centerTitle: true
      ),
      body: Container(
        decoration: const BoxDecoration(color: Colors.white),
        child:ConstrainedBox(                          /// 约束盒子
          constraints: const BoxConstraints.expand(),  /// 不指定高和宽时则铺满整个屏慕
            child: Stack(
            alignment:Alignment.center ,               /// 指定对齐方式为居中
            children: <Widget>[                        /// 子组件列表
              controller.obx((state) => Center(
                child: controller.${tableName}List.value.isNotEmpty?
                /// MyListView 是一个自定义的列表显示组件 
                /// https://blog.csdn.net/weixin_40929065/article/details/123797218
                ${titleCase(tableName)}ListView(
                  datas: controller.${tableName}List.value,
                  onPressed: (item) {
                    print(item);
                    print("点击查看");
                  },
                  doublePressed: (item) {
                    print(item);
                    print("双击编辑");
                    controller.dataForm = item;
                    controller.toEditPage();
                  },
                  longPressed: (item) {
                    print(item);
                    print("长按删除");
                    checkDel(context,item);
                  },
                  onTap: (id) {
                    print(id);
                    print("点击获取id");
                  },
                  dropdown: () { controller.get${titleCase(tableName)}List(); },
                  pullup: () { 
                    print("上拉加载回调");
                    // controller.get${titleCase(tableName)}ListMore(); 
                  },
                )
                :const Text("暂无记录"),
              )),
              Positioned(
                top: 0.0,
                child: 
                /// MySearchFence 是一个自定义的搜索组件
                /// https://blog.csdn.net/weixin_40929065/article/details/123638686
                SearchFence(
                  onSearch:(value){controller.search.text = value; controller.get${titleCase(tableName)}List();},
                  hasRightIcon: false,
                  rightIcon: Icons.flip,
                  onIcon:(value){controller.search.text = value; controller.get${titleCase(tableName)}List();},
                  onChange: (value) {  },
                  onClean: (value) {  },
                ),
              ),
            ],
          ),
        ),
      ),
      floatingActionButton: FloatingActionButton(
        backgroundColor: Colors.transparent,
        foregroundColor: Colors.black87,
        elevation: 0,
        onPressed: () {controller.toEditPage();},
        child: const Icon(Icons.post_add_outlined),
      ),
    );
  }
}
`
}
